import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import BaseApi from "../../../../functions/axios";
import FormUserRegisterButton from "../molecules/FormUserRegisterButton";
import NonIconButton from "../../../../components/NonIconButton";
import { userRegisterContext } from "../../UserRegisterPage";
import NameField from "../molecules/NameField";
import MailaddressField from "../molecules/MailaddressField";
import PasswordField from "../molecules/PasswordField";
import PasswordConfirmField from "../molecules/PasswordConfirmField";
import UserClassField from "../molecules/UserClassField";
import MailNotificationField from "../molecules/MailNotificationField";
import { useLocalStorage } from "../../../../hooks/localStrage";

const schema = yup.object({
  email: yup
    .string()
    .required("メールアドレスを入力してください")
    .email("正しいメールアドレス入力してください。"),
  name: yup
    .string()
    .required("名前を入力してください")
    .min(2, "正しい名前を入力してください"),
  password: yup
    .string()
    .required("英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .min(8, "英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&].*$/,
      "英字・数字を組み合わせた8文字以上のパスワードを入力してください"
    ),
  confirm: yup
    .string()
    .required("英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .min(8, "英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&].*$/,
      "英字・数字を組み合わせた8文字以上のパスワードを入力してください"
    )
    .oneOf([yup.ref("password")], "passwordが一致しません"),
});

const inputAutofillStyle = {
  "& .MuiInputBase-input": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
  },
};

export default function UserRegisterForm() {
  const { mailNotification, userClass } = useContext(userRegisterContext);
  const navigate = useNavigate();
  const [, setCurrentPage] = useLocalStorage("currentPage");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (event) => {
    const postData = {
      name: event.name,
      email: event.email,
      password: event.password,
      confirm: event.confirm,
      admin_flag: userClass,
      notification_flag: mailNotification,
    };

    BaseApi.post("regist_user", postData).then(() => {
      setCurrentPage(process.env.REACT_APP_DASHBOARD_NUM);
      navigate("/dashboard");
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
      <NameField register={register} classes={inputAutofillStyle} errors={errors} />
      <MailaddressField register={register} classes={inputAutofillStyle} errors={errors} />
      <PasswordField register={register} errors={errors} />
      <PasswordConfirmField register={register} errors={errors} />
      <UserClassField />
      <MailNotificationField />

      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "space-around", sm: "space-evenly" },
          m: { xs: 1, sm: 2 },
          p: 2,
        }}
      >
        <Box sx={{ width: { xs: "110px", sm: "200px" } }}>
          <NonIconButton
            title="キャンセル"
            clickEvent={() => navigate("/adminManagement")}
          />
        </Box>
        <Box sx={{ width: { xs: "120px", sm: "200px" } }}>
          <FormUserRegisterButton />
        </Box>
      </Box>
    </Box>
  );
}